import React from 'react'
import axios from 'axios'
import styled from 'styled-components'
import { Modal } from "Components/readonly";
import useModalController from 'Hooks/useModalController';
import modalContentConfirm from 'Components/combined/modalContentComponents/modalContentConfirm'
import { Button, Switch, TextInput } from '../input'
import { useIntl } from 'react-intl'
import LocationUnitDropdown from 'Components/input/locationUnitDropdown'
import { FieldError } from 'Components/layout'

const Field = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  > div {
    width: 100px;
    margin-right: 10px;
    text-align: center;

    > label {
      display: inline-block;
      margin-bottom: 2px;
      width: 100px;
    }
  }

  .switch-container {
    width: auto;
    margin-right: 10px;
    display: flex;
    column-gap: 5px;
    position: relative;
    bottom: -11px;

    label {
      padding-top: 3px;
    }
  }

  .trash {
    width: 50px;
    margin-right: 0;
    margin-top: 29px;

    button {
      margin-bottom: 0;
    }
  }

  @media screen and (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;

    > div {
      width: 100%;
      margin-bottom: 10px;
    }

    .trash {
      margin-top: 10px;
    }
  }

  ${FieldError} {
    width: auto;
    margin: 0;
  }
`

const NewPackageRow = ({ id, value, onChange, validationError, remove, disableRemove }) => {
  const intl = useIntl()
  const [deletePackageModalController] = useModalController({ title: intl.formatMessage({ id: 'common.delete' }) })

  const setAmount = (input) => {
    let v = { ...value }
    v.amount = input
    onChange({ target: { value: v } })
  }

  const setOpened = (input) => {
    let v = { ...value }
    v.amount_opened = input
    onChange({ target: { value: v } })
  }

  const onBulkChange = (input) => {
    let v = { ...value }
    v.is_bulk = input
    onChange({ target: { value: v } })
  }

  const setPackageSize = (input) => {
    let v = { ...value }
    v.packaging_size = input
    onChange({ target: { value: v } })
  }

  const updateUnit = (input, unit) => {
    let v = { ...value }
    v.unit_id = input
    v.unit = unit
    v.unit.id = input
    onChange({ target: { value: v } })
  }


  /**
   * This will make a post request to the backend and remove product if exists
   * @returns {Promise<void>}
   */
  const deletePackage = async () => {
    if(value.id) {
      try {
       await axios.post('/rapi/chemicals/delete-package', {
          id: value.id
        })
      } catch (e) {
        console.error("Unexpected axios post request error", e);
      }
    }
    remove();
  };

  return (
    <Field>
      <Modal
        modalController={deletePackageModalController}
        ContentComponent={modalContentConfirm}
        contentTextId="admin.delete_package_text"
        confirmTextId="common.delete"
        onConfirm={deletePackage}
      />
      {validationError && <FieldError/>}
      {
        <>
          <div className="switch-container">
            <span>{intl.formatMessage({ id: 'chemicals.bulk' })}</span>
            <Switch
              value={value.is_bulk}
              onChange={(e) => onBulkChange(e.target.value)}
              onLabel={intl.formatMessage({ id: 'common.yes' })}
              offLabel={intl.formatMessage({ id: 'common.no' })}
            />
          </div>
          {value.is_bulk ? (
            <div>
              <label>{intl.formatMessage({ id: 'chemicals.amount' })}</label>
              <TextInput
                id={id + '-amount'}
                keyfilter="pnum"
                type="number"
                value={value.amount}
                onChange={(e) => {
                  setAmount(e.target.value)
                }}
                className={validationError && validationError.amount ? 'ui-state-error' : ''}
                style={{ width: '80px', textAlign: 'center' }}
              />
            </div>
          ) : (
            <div>
              <label>{intl.formatMessage({ id: 'chemicals.size' })}</label>
              <TextInput
                id={id + '-packaging_size'}
                keyfilter="pint"
                type="number"
                value={value.packaging_size}
                onChange={(e) => {
                  setPackageSize(e.target.value)
                }}
                className={validationError && validationError.packaging_size ? 'ui-state-error' : ''}
                style={{ width: '80px', textAlign: 'center'}}
              />
            </div>
          )}
          <div>
            <label>{intl.formatMessage({ id: 'chemicals.unit' })}</label>
            <LocationUnitDropdown
              id={id + '-unit_id'}
              value={value.unit_id}
              onChange={(e, unit) => updateUnit(e.target.value, unit)}
              appendTo={document.body}
              className={validationError && validationError.unit_id ? 'ui-state-error' : ''}
              style={{ width: '80px', height: '34px', lineHeight: '13px'}}
            />
          </div>
          {!value.is_bulk && (
            <>
              <div>
                <label>{intl.formatMessage({ id: 'chemicals.opened' })}</label>
                <TextInput
                  id={id + '-amount_opened'}
                  keyfilter="pnum"
                  type="number"
                  value={value.amount_opened}
                  onChange={(e) => {
                    setOpened(e.target.value)
                  }}
                  className={validationError && validationError.amount_opened ? 'ui-state-error' : ''}
                  style={{ width: '80px', textAlign: 'center'}}
                />
              </div>
              <div>
                <label>{intl.formatMessage({ id: 'chemicals.unopened' })}</label>
                <TextInput
                  id={id + '-amount'}
                  keyfilter="pnum"
                  type="number"
                  value={value.amount}
                  onChange={(e) => {
                    setAmount(e.target.value)
                  }}
                  className={validationError && validationError.amount ? 'ui-state-error' : ''}
                  style={{ width: '80px', textAlign: 'center'}}
                />
              </div>
              <TextInput
                id={id + '-hidden'}
                keyfilter="pnum"
                type="hidden"
                value={value.id}
                style={{ width: '80px', textAlign: 'center'}}
              />

            </>
          )}
          <div className="trash">
            <Button primary onClick={() => {
              deletePackageModalController.open({ data: value })
            }} icon="pi pi-trash" disabled={disableRemove}/>
          </div>
        </>
      }
    </Field>
  )
}

export default NewPackageRow
